module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/vocabulary/components/delete-code-system-confirmation-dialog.component.scss
// module id = ./src/app/vocabulary/components/delete-code-system-confirmation-dialog.component.scss
// module chunks = main